// extracted by mini-css-extract-plugin
module.exports = {"applyRed":"antd-pro-containers-payment-desk-styles-applyRed","applyGreen":"antd-pro-containers-payment-desk-styles-applyGreen"};